import { Injectable } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { OrderQuery } from '@modules/order/state/order-query';
import { Tooth } from '@modules/teeth-diagram/models/tooth';
import { ArtTreatmentDefinition, ArtTreatmentIntegrity } from '../models';
import { ArtTreatmentRulesService } from './art-treatment-rules.service';
import { ART_PRESET_TOOTH_IDS } from '../constants/art-treatment.constants';

const PRESET_TOOTH_IDS: ReadonlySet<number> = new Set(ART_PRESET_TOOTH_IDS);

@Injectable({ providedIn: 'root' })
export class ValidateArtRxService {
	constructor(
		private readonly artRulesService: ArtTreatmentRulesService,
		private readonly orderQuery: OrderQuery
	) {}

	get isArtProcedure(): boolean {
		return this.orderQuery.procedureMap?.ProcedureId === ProcedureEnum.InvisalignART;
	}

	isTreatmentInvalidForSend(tooth: Tooth): boolean {
		const treatment = tooth.ArtTreatment;

		if (!treatment) {
			return false;
		}

		const toothIntegrity = treatment.Integrity as ArtTreatmentIntegrity;
		const toothDefinitions = treatment.Definitions as ArtTreatmentDefinition[];
		const allowedDefinitionsForIntegrity = this.artRulesService.definitionMapping.get(toothIntegrity);

		if (!Array.isArray(allowedDefinitionsForIntegrity) || !Array.isArray(toothDefinitions)) {
			return true;
		}

		const isPresetTooth = tooth.ToothID != null && PRESET_TOOTH_IDS.has(tooth.ToothID);
		const allowedDefinitionsForTooth = isPresetTooth
			? [...allowedDefinitionsForIntegrity, ArtTreatmentDefinition.Unmovable]
			: allowedDefinitionsForIntegrity;

		return toothDefinitions.some(definition => !allowedDefinitionsForTooth.includes(definition));
	}
}
